// 根据code获取指定值
import { isArray } from 'lodash-es'
import { message } from 'antd'
import { fileConfirm } from '@/utils/common'

export const getDoc = (code: string, list: [], key = 'dataValue') => {
  let title = ''
  isArray(list) &&
    list.forEach((item: any) => {
      if (item[key] === code) {
        title = item.name
      }
    })
  return title
}

export const getAllDoc = (code: [], list: [], key = 'code') => {
  const newArr =
    isArray(list) &&
    list.reduce((res, item) => {
      if (code && code.includes(item[key])) res.push(item)
      return res
    }, [])
  const titleArr = newArr.map(item => item.name)
  return titleArr.join(',')
}

export const onDownLoadFile = (downLoadFn: (id?) => Promise<any>, id?) => {
  message.loading({ content: '下载中', duration: 0 })
  downLoadFn(id)
    .then((res: any) => {
      message.destroy()
      if (res.status && res.status === 200) {
        fileConfirm()
      } else {
        message.error('下载失败')
      }
    })
    .catch(() => {
      message.destroy()
    })
}
